import { AlertNoteComponent } from '../../components/AlertNoteComponent/AlertNoteComponent.js';
import { DialogComponent } from '../../components/DialogComponent/DialogComponent.js';
import { NotificationComponent } from '../../components/NotificationComponent/NotificationComponent.js';
import { PopoverComponent } from '../../components/PopoverComponent/PopoverComponent.js';
import { ProgressBarComponent } from '../../components/ProgressBarComponent/ProgressBarComponent.js';
import { SliderComponent } from '../../components/SliderComponent/SliderComponent.js';

// core/tools/RegisterComponent.ts
/**
 * Регистрирует Web Component в Custom Elements Registry.
 *
 * @param name      Имя кастомного элемента (например: 'im-progress-bar').
 * @param ctor      Класс компонента (наследник HTMLElement).
 * @returns         Зарегистрированный класс (для удобства).
 */
function registerComponent(name, ctor) {
    const existing = customElements.get(name);
    if (existing) {
        if (existing !== ctor) {
            console.error(`[componentRegister] Имя "${name}" уже занято другим компонентом`, existing);
        }
        return existing;
    }
    customElements.define(name, ctor);
    return ctor;
}
/** Регистрация компонентов */
function registerComponents() {
    registerComponent('im-alert-note', AlertNoteComponent);
    registerComponent('im-dialog', DialogComponent);
    registerComponent('im-notification', NotificationComponent);
    registerComponent('im-progress-bar', ProgressBarComponent);
    registerComponent('im-slider', SliderComponent);
    registerComponent('im-popover', PopoverComponent);
}

export { registerComponent, registerComponents };
